
export const unitlessKeys = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
  
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1,
  };


  
  /* https://www.quackit.com/css/at-rules/ */
  
export const CSSPseudo = [
  ':active',
  '::after',
  '::backdrop ',
  '::before',
  ':checked',
  ':default',
  ':dir',
  ':disabled',
  ':empty',
  ':enabled',
  ':first-child',
  ':first-of-type',
  ':focus',
  ':fullscreen ',
  ':hover',
  ':in-range',
  ':indeterminate',
  ':invalid',
  ':lang',
  ' :last-child',
  ':last-of-type',
  ':not',
  ':nth-child',
  ':nth-last-child',
  ':nth-last-of-type',
  ':nth-of-type',
  ':only-child',
  ':only-of-type',
  ':optional',
  ':out-of-range',
  '::placeholder',
  ':read-only',
  ':read-write',
  ':required',
  ':root',
  '::selection',
  ':scope',
  ':target',
  ':valid',
  ':visited',
];

export const CSSatRules =[
  '@bottom-center',
  '@bottom-left',
  '@bottom-left-corner',
  '@bottom-right',
  '@bottom-right-corner',
  '@charset',
  '@counter-style',
  '@document',
  '@font-face',
  '@font-feature-values',
  '@import',
  '@left-bottom',
  '@left-middle',
  '@left-top',
  '@keyframes',
  '@media',
  '@namespace',
  '@page',
  '@right-bottom',
  '@right-middle',
  '@right-top',
  '@supports',
  '@top-center',
  '@top-left',
  '@top-left-corner',
  '@top-right',
  '@top-right-corner', 
]

export const CSSatRulesDescriptors = [
  "additive-symbols",
  "bleed",
  "fallback",
  "font-family",
  "font-feature-settings",
  "font-style",
  "font-weight",
  "font-stretch",
  "font-variant",
  "marks",
  "negative",
  "pad",
  "prefix",
  "range",
  "speak-as",
  "src",
  "suffix",
  "symbols",
  "system",
  "unicode-range"
]